/**
 * Validatori Foundation Identity (frontend).
 *
 * Validazione formale del Codice Fiscale italiano e dell'email.
 * Il checksum viene calcolato lato client per fornire feedback immediato.
 */

const CF_PATTERN = /^[A-Z]{3}[A-Z]{3}[0-9]{2}[ABCDEHLMPRST][0-9]{2}[A-Z][0-9]{3}[A-Z]$/;

const ODD_MAP = {
  "0": 1, "1": 0, "2": 5, "3": 7, "4": 9, "5": 13, "6": 15, "7": 17, "8": 19, "9": 21,
  "A": 1, "B": 0, "C": 5, "D": 7, "E": 9, "F": 13, "G": 15, "H": 17, "I": 19, "J": 21,
  "K": 2, "L": 4, "M": 18, "N": 20, "O": 11, "P": 3, "Q": 6, "R": 8, "S": 12, "T": 14,
  "U": 16, "V": 10, "W": 22, "X": 25, "Y": 24, "Z": 23,
};
const EVEN_MAP = {
  "0": 0, "1": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9,
  "A": 0, "B": 1, "C": 2, "D": 3, "E": 4, "F": 5, "G": 6, "H": 7, "I": 8, "J": 9,
  "K": 10, "L": 11, "M": 12, "N": 13, "O": 14, "P": 15, "Q": 16, "R": 17, "S": 18,
  "T": 19, "U": 20, "V": 21, "W": 22, "X": 23, "Y": 24, "Z": 25,
};
const CHECK_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function normalizeFiscalCode(cf) {
  if (!cf) return "";
  return String(cf).replace(/\s+/g, "").toUpperCase();
}

export function validateFiscalCode(cf) {
  const norm = normalizeFiscalCode(cf);
  if (!norm) return { valid: false, error: "Codice Fiscale mancante" };
  if (norm.length !== 16) return { valid: false, error: "Deve essere di 16 caratteri" };
  if (!CF_PATTERN.test(norm)) return { valid: false, error: "Formato non valido" };
  // checksum
  let sum = 0;
  for (let i = 0; i < 15; i++) {
    const ch = norm[i];
    // posizione 1-based dispari usa ODD_MAP
    sum += ((i + 1) % 2 === 1) ? ODD_MAP[ch] : EVEN_MAP[ch];
  }
  const expected = CHECK_CHARS[sum % 26];
  if (expected !== norm[15]) {
    return { valid: false, error: "Carattere di controllo non valido" };
  }
  return { valid: true, normalized: norm };
}

export function validateEmail(email) {
  if (!email) return { valid: false, error: "Email mancante" };
  const norm = String(email).trim().toLowerCase();
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!pattern.test(norm)) return { valid: false, error: "Formato email non valido" };
  return { valid: true, normalized: norm };
}
